import { useIntakeManagementPageProps } from '~/data';
import { IntakeCreateLayout } from './layouts';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';

export function IntakeCreatePage() {
  useWindowDocumentTitle('Add New Intake');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } =
    useIntakeManagementPageProps();

  if (!isInitialPropsError && isLoadingInitialProps) {
    return <LoadingPage />;
  }
  if (isInitialPropsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (!initialProps) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return <IntakeCreateLayout initialProps={initialProps} />;
}
